import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { SidebarDataProps } from './sidebar-data'
import { IconArrowLeftSvg } from '../../assets/icons/svgComponents'

type SidebarItemProps = {
  sidebar: boolean
  item: SidebarDataProps
}

const SidebarItem = ({ sidebar, item }: SidebarItemProps) => {
  const [dropdown, setDropdown] = useState(false)

  useEffect(() => {
    setDropdown(false)
  }, [sidebar])

  return (
    <div
      key={item.title}
      className={`${dropdown && sidebar ? 'dropActive' : ''} ${item.cName}`}
      onClick={
        item.cName.includes('dropdown')
          ? () => setDropdown(!dropdown)
          : () => ({})
      }
    >
      {sidebar ? (
        item.hasDropdown.length ? (
          <>
            <Link to="#">
              {item.icon}
              <span>{item.title}</span>
              <IconArrowLeftSvg className="icon-arrow-left" />
            </Link>
            <div className="dropdown-menu-content">
              {item.hasDropdown.map(
                (itemDrop: {
                  name?: string
                  onClick?: Dispatch<SetStateAction<boolean>>
                }) => (
                  <Link
                    onClick={() => itemDrop.onClick?.(true)}
                    key={itemDrop.name}
                    to={
                      itemDrop.onClick
                        ? ''
                        : `/${
                            itemDrop.name
                              ? itemDrop.name
                                  .toLowerCase()
                                  .replaceAll(' ', '-')
                                  .replace('çõ', 'co')
                              : ''
                          }`
                    }
                  >
                    {itemDrop.name}
                  </Link>
                )
              )}
            </div>
          </>
        ) : (
          <Link to={item.path}>
            {item.icon}
            <span>{item.title}</span>
          </Link>
        )
      ) : (
        <span className="sidebar-icon">{item.icon}</span>
      )}
    </div>
  )
}

export default SidebarItem
